import styled from "styled-components";

export const Container = styled.span`
  > span,
  > h1 {
    position: relative;
    display: inline-block;
  }

  > span {
    font-weight: bold;
  }

  > span::before,
  > h1::before {
    position: absolute;
    content: "";
    z-index: -1;
    transform: translate(-50%, -0%);
    background: ${(props) =>
      props.$background === "#28a137" ? "#28a137" : "#1A3458"};
    width: 100%;
    top: 50%;
    left: 50%;
    height: 50%;
    border-radius: 0px;
  }
`;
